// Look up if loading=lazy will break on video

import supports from '../lib/supports.js';

/**
 * Lazyload video poster image
 * @param {HTMLElement} video video target from IntersectionObserver
 */
const loadPosterImg = (video) => {
  if (video.dataset.poster) {
    const poster = video.dataset.poster;
    video.setAttribute('poster', poster);
  }
};

/**
 * Lazyload video sources
 * @param {HTMLElement} video video target from IntersectionObserver
 */
const loadVideoSrc = (video) => {
  for (const source in video.children) {
    if (Object.prototype.hasOwnProperty.call(video.children, source)) {
      const videoSource = video.children[source];
      if (typeof videoSource.tagName === 'string' && videoSource.tagName === 'SOURCE') {
        videoSource.src = videoSource.dataset.src;
      }
    }
  }

  // Trigger play
  video.load();
};

/**
 * Add class for animating lazyloaded video appearing
 * and remove intersection observer
 * @param {HTMLElement} video video target from IntersectionObserver
 */
const videoCleanup = (video) => {
  // Remove lazy class
  video.classList.add('is-loaded');

  // Remove Intersection observer
  lazyVideoObserver.unobserve(video);
};

const lazyVideoObserver = new IntersectionObserver((entries, observer) => {
  entries.forEach((video) => {
    if (video.isIntersecting) {
      loadPosterImg(video.target);
      loadVideoSrc(video.target);
      videoCleanup(video.target);
    }
  });
});

// const lazyloadDestroy = (container = document) => {
//   const lazyVideos = container.querySelectorAll('.lazy');

//   if (lazyVideos && lazyVideos.length > 0 && supports.intersectionObserver) {
//     lazyVideos.forEach((lazyVideo) => {
//       lazyVideoObserver.unobserve(lazyVideo);
//     });
//   }
// };

const lazyLoad = {
  init() {
    const lazyVideos = document.querySelectorAll('[data-module="lazy"]');

    if (lazyVideos && lazyVideos.length > 0 && supports.intersectionObserver) {
      lazyVideos.forEach((lazyVideo) => {
        lazyVideoObserver.observe(lazyVideo);
      });
    }
  },
};

export default lazyLoad;
